import { db } from '../Index';
import { isAnimal } from '../functions/IsAnimal';
import { GetLocalRegisters } from '../functions/GetLocalRegisters';
import { IAnimal } from '../DexieDB/modules/animals/entities/IAnimal';

type DataType =
  | 'propriedades'
  | 'animais'
  | 'animal'
  | 'usuarios'
  | 'registros'
  | 'filtrosValidos'
  | 'registro';

// 'animais' para retornar uma lista de animais, 'animal' para retornar um único
// o mesmo se aplica para as outras entidades

export async function BuscarLocalmente(
  dataType: DataType,
  url: string,
  config: any,
) {
  if (dataType === 'propriedades') {
    const properties = await db
      .table(dataType)
      .where('id')
      .equals(config.headers.propriedade_id)
      .toArray();

    return properties[0];
  } else if (dataType === 'usuarios') {
    const id = url.replace('/usuarios/perfil/', '');
    const users = await db.table(dataType).where('id').equals(id).toArray();

    return users[0];
  } else if (dataType === 'animal') {
    const id = url.replace('/animais/', '');
    const data = await db.animais.where('id').equals(id).toArray();

    let toPerformData = await db.toPerform.toArray();
    toPerformData.filter(item => isAnimal(item.data) && item.id === id);

    const animaisToPerform: IAnimal[] = toPerformData.map(item => {
      return item.id === id
        ? {
            id: item.id,
            ...item.data,
            estado: 'ativo',
            imagens: [],
          }
        : null;
    });

    const filtered = animaisToPerform.filter(function (el) {
      return el != null;
    });

    return data.length > 0 ? data[0] : filtered[0];
  } else if (dataType === 'registro') {
    const id = url.replace('/registros/', '');

    const registros = await GetLocalRegisters(
      config.headers.animal_id,
      { id },
      1,
    );

    return registros[0];
  } else if (dataType === 'registros') {
    const animalId = url.replace('/registros/todos/', '');

    const conditions = config.params.keyword
      ? {
          animal_id: animalId,
          categoria: config.params.keyword,
        }
      : {
          animal_id: animalId,
        };

    const registros = await GetLocalRegisters(
      animalId,
      conditions,
      config.params.limite,
    );

    return registros;
  } else if (dataType === 'filtrosValidos') {
    const filters = await db.filtrosValidos
      .where('id')
      .equals(config.headers.propriedade_id)
      .toArray();

    return filters[0];
  }
}
